import { render, staticRenderFns } from "./Main-comp.vue?vue&type=template&id=284a4bbc&scoped=true&"
import script from "./Main-comp.vue?vue&type=script&lang=js&"
export * from "./Main-comp.vue?vue&type=script&lang=js&"
import style0 from "./Main-comp.vue?vue&type=style&index=0&id=284a4bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a4bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
